export default [
  {
    path: window.pathApp + '/pagamento-rapido',
    name: 'pagamento.rapido',
    component: () => import('@/components/PagamentoRapido/Central'),
    meta: {
      login: false,
      avisoCarrinho: false,
      title: "Pagamento Rápido",
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/pagamento_rapido.js